module.exports = __webpack_public_path__ + "static/img/DONE-answer.1f16cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DONE-answer.png
// module id = l/5n
// module chunks = 0